import { createListPage, createDetailPage } from 'pages/common'
import { api } from 'store/modules/wines'
import { actionCreators } from 'store/modules/wines'
import Content from './grid'
import Form from './form'

import { urls } from 'urls'

const PAGE = 'wines'

export const metadata = {
  icon: 'glass',
  page: PAGE,
  urls: urls[PAGE],
  isSoftDelete: false,
  enableSaveAsNew: true
}

const WinesListPage = createListPage({ metadata, api, actionCreators, Content })
const WinesDetailPage = createDetailPage({ metadata, actionCreators, Form })

export { WinesListPage, WinesDetailPage }

